import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase-config';
import { getCallableMessage, unwrapCallableData } from './callableResponse';
import { CustomProductBulkTarget } from '../types/customProductBulkActions';

interface AssignBrandKeywordsToCustomProductRequest {
  companyId: string;
  productId: string;
  categoryKey?: string;
}

interface AssignBrandKeywordsToCustomProductResponse {
  companyId: string;
  productId: string;
  jobId: string;
}

type AssignBrandKeywordsToCustomProductsRequest = {
  companyId: string;
} & Partial<CustomProductBulkTarget>;

interface AssignBrandKeywordsToCustomProductsResponse {
  companyId: string;
  jobId?: string;
  scheduledCount: number;
  requestedCount?: number;
  skippedCount?: number;
  jobCreated?: boolean;
  message?: string;
}

const assignBrandKeywordsToCustomProduct = async (
  payload: AssignBrandKeywordsToCustomProductRequest,
): Promise<AssignBrandKeywordsToCustomProductResponse> => {
  const fn = httpsCallable<
    AssignBrandKeywordsToCustomProductRequest,
    AssignBrandKeywordsToCustomProductResponse
  >(functions, 'handle_assign_brand_keywords_to_custom_product');

  const result = await fn(payload);
  return unwrapCallableData<AssignBrandKeywordsToCustomProductResponse>(result.data);
};

const assignBrandKeywordsToCustomProducts = async (
  companyId: string,
  target?: CustomProductBulkTarget,
): Promise<AssignBrandKeywordsToCustomProductsResponse> => {
  const fn = httpsCallable<
    AssignBrandKeywordsToCustomProductsRequest,
    AssignBrandKeywordsToCustomProductsResponse
  >(functions, 'handle_assign_brand_keywords_to_custom_products');

  const result = await fn({ companyId, ...target });
  return {
    ...unwrapCallableData<AssignBrandKeywordsToCustomProductsResponse>(result.data),
    message: getCallableMessage(result.data),
  };
};

export { assignBrandKeywordsToCustomProduct, assignBrandKeywordsToCustomProducts };
